<template>
  <div class="list-comment-cells">
    <div
      v-for="column in columns"
      :key="'comment-total-' + column.column_id"
      class="list-comment-cell-item"
    ></div>
  </div>
</template>

<script>
export default {
  name: "listCommentTotalCell",
  props: {
    columns: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.list-comment-cells {
  display: flex;
  flex-flow: row;
  align-items: stretch;
  width: max-content;
  min-width: 100%;
}
.list-comment-cell-item {
  min-width: 140px;
  width: 140px;
  max-width: 140px;
  flex-shrink: 0;
  box-sizing: border-box;
}
</style>
